module.exports = __webpack_public_path__ + "static/media/POPCORN_1.79e3b264.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/POPCORN_1.png
// module id = 184
// module chunks = 0